module.exports = __webpack_public_path__ + "assets/img/00031.2eefc109.png";